module.exports = __webpack_public_path__ + "img/ingles individual.75c7f3fa.svg";